import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays } from "lucide-react";

export const toISODate = (d) => { const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000); return z.toISOString().slice(0, 10); };
export const fmtDue = (iso) => { try { return new Date(iso + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" }); } catch { return iso; } };
export const isOverdue = (c) => c.due && !c.done && new Date(c.due + "T00:00:00") < new Date(new Date().toDateString());
export const pct = (list) => (!list || list.length === 0 ? 0 : Math.round((list.filter((c) => c.done).length / list.length) * 100));

export function DueControl({ c, editor, onSet }) {
  const [open, setOpen] = useState(false);
  const overdue = isOverdue(c);
  if (!editor) return c.due ? <span data-testid="due-label" className={`text-xs whitespace-nowrap ${overdue ? "text-destructive font-medium" : "text-muted-foreground"}`}>{fmtDue(c.due)}</span> : null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="due-btn"
          className={`text-xs whitespace-nowrap inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm border transition-colors ${c.due ? (overdue ? "border-destructive/40 text-destructive" : "border-border text-muted-foreground") : "border-dashed border-border text-muted-foreground/60 hover:text-primary hover:border-primary/50"}`}>
          <CalendarDays className="h-3 w-3" />{c.due ? fmtDue(c.due) : "Due"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end">
        <Calendar mode="single" selected={c.due ? new Date(c.due + "T00:00:00") : undefined}
          onSelect={(d) => { onSet(d ? toISODate(d) : ""); setOpen(false); }} initialFocus />
        {c.due && <div className="p-2 border-t border-border"><Button variant="ghost" size="sm" className="w-full" data-testid="due-clear" onClick={() => { onSet(""); setOpen(false); }}>Clear due date</Button></div>}
      </PopoverContent>
    </Popover>
  );
}
